import type { FC } from 'react';

export interface InfoIconProps {
    className?: string;
}

export const InfoIcon: FC<InfoIconProps> = ({ className }) => (
    <svg fill="none" className={className} viewBox="0 0 312 224">
        <path
            d="m154.467 6.47008 4.697-3.84321c2.824-2.307429 6.825-1.962814 9.215.79411l29.622 27.68162"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M155.869 8.00489c.119-1.76053-1.124-3.27384-2.787-3.38622-1.663-.11237-3.102 1.22114-3.229 2.98167-.113 1.75305 1.124 3.27386 2.787 3.38626 1.663.1123 3.101-1.22117 3.229-2.98171ZM92.3471 215.315l-5.9409-13.867h26.1008l-20.1599 13.867Z"
            fill="#1A1A1A"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M98.2028 219.4c2.6172-3.974 2.2482-8.835-.8232-10.859-3.0719-2.023-7.6837-.442-10.3009 3.532-2.6172 3.974-2.2486 8.835.8232 10.858 3.0718 2.024 7.6837.442 10.3009-3.531Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M94.7102 217.101c.974-1.479.8365-3.289-.3073-4.042-1.1437-.753-2.8605-.165-3.8345 1.314-.9741 1.479-.8365 3.288.3072 4.041 1.1437.754 2.8605.166 3.8346-1.313Zm56.4608-1.786-5.941-13.867h26.109l-20.168 13.867Z"
            fill="#1A1A1A"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M157.025 219.396c2.617-3.974 2.249-8.835-.823-10.859-3.072-2.023-7.684-.442-10.301 3.532s-2.249 8.835.823 10.858c3.072 2.024 7.684.442 10.301-3.531Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M153.534 217.097c.974-1.479.837-3.289-.307-4.042-1.144-.753-2.86-.165-3.834 1.314-.974 1.479-.837 3.288.307 4.042 1.144.753 2.86.165 3.834-1.314ZM43.2246 159.673s50.0217.262 67.4774 7.311c10.069 4.068 27.052 6.016 39.616 6.938 10.068.741 20.085-1.971 28.385-7.709l1.229-.847-6.503-6.435-78.9316-27.157-51.2728 27.899Zm53.5126-95.4591L57.1738 128.29l48.2462-22.078-8.6828-41.9981Z"
            fill="#1A1A1A"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="m122.449 74.0291-46.3656-17.006s-2.4947-8.4056-7.8062-8.2633c-6.9748.1873-4.6299 11.6795 1.5807 13.6198 6.2106 1.9404 46.1561 17.3282 46.1561 17.3282"
            fill="#fff"
        />
        <path
            d="m122.449 74.0291-46.3656-17.006s-2.4947-8.4056-7.8062-8.2633c-6.9748.1873-4.6299 11.6795 1.5807 13.6198 6.2106 1.9404 46.1561 17.3282 46.1561 17.3282"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M188.412 123.347s40.499 13.844 46.515 16.339c6.008 2.494 15.186-4.81 9.957-9.425-3.978-3.513-11.29 1.326-11.29 1.326l-46.471-16.721"
            fill="#fff"
        />
        <path
            d="M188.412 123.347s40.499 13.844 46.515 16.339c6.008 2.494 15.186-4.81 9.957-9.425-3.978-3.513-11.29 1.326-11.29 1.326l-46.471-16.721"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M210.445 100.219s42.785-1.3564 49.287-1.1467c6.503.2098 12.512-9.859 5.986-12.3387-4.967-1.8804-10.091 5.2292-10.091 5.2292l-49.385.7716"
            fill="#fff"
        />
        <path
            d="M210.445 100.219s42.785-1.3564 49.287-1.1467c6.503.2098 12.512-9.859 5.986-12.3387-4.967-1.8804-10.091 5.2292-10.091 5.2292l-49.385.7716"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="m108.041 93.9646-49.257-3.6185s-4.7123-7.3942-9.7766-5.7985c-6.6526 2.0976-1.2436 12.496 5.2666 12.6608 6.5027.1649 49.138 3.9856 49.138 3.9856"
            fill="#fff"
        />
        <path
            d="m108.041 93.9646-49.257-3.6185s-4.7123-7.3942-9.7766-5.7985c-6.6526 2.0976-1.2436 12.496 5.2666 12.6608 6.5027.1649 49.138 3.9856 49.138 3.9856"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M151.544 143.648c-6.166 20.056-12.354 39.197-.18 43.257 12.714 4.24 9.702 14.084 9.702 14.084l-40.552.465 18.983-51.827"
            fill="#fff"
        />
        <path
            d="M151.544 143.648c-6.166 20.056-12.354 39.197-.18 43.257 12.714 4.24 9.702 14.084 9.702 14.084l-40.552.465 18.983-51.827"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M220.912 70.8065c-4.48 8.0011-13.351 12.4361-23.052 12.5485 5.184 7.9561 6.188 17.598 1.7 25.606-4.48 8.002-13.35 12.444-23.051 12.549 5.191 7.964 6.188 17.598 1.7 25.606-7.012 12.519-24.737 16.31-39.616 8.466-14.87-7.844-21.253-24.355-14.256-36.874 4.48-8.008 11.634-13.088 21.336-13.193-5.192-7.9633-4.48-16.9608 0-24.9693 4.48-8.0011 13.35-12.4437 23.052-12.5485-5.184-7.9562-6.188-17.5979-1.701-25.6065 7.012-12.5185 24.745-16.3093 39.616-8.4655 14.871 7.8437 21.254 24.3553 14.257 36.8738l.015.0075Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="m136.113 123.631-16.916 20.879-41.9529 1.027 6.4878 42.492s9.6492-3.086 11.4772-15.567c2.0152-13.77 4.6298-9.455 25.9139-16.654 3.498-1.184 6.48-3.559 8.413-6.705l14.623-19.194"
            fill="#fff"
        />
        <path
            d="m136.113 123.631-16.916 20.879-41.9529 1.027 6.4878 42.492s9.6492-3.086 11.4772-15.567c2.0152-13.77 4.6298-9.455 25.9139-16.654 3.498-1.184 6.48-3.559 8.413-6.705l14.623-19.194"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="m274.783 81.9947-16.376 39.5483c-.757 2.772-4.75 4.098-10.841 2.435-6.083-1.656-8.855-4.825-8.098-7.597l5.963-42.3873 29.36 8.001h-.008Z"
            fill="#1A1A1A"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M274.782 81.9835c-.299 1.0863-1.146 1.9628-2.412 2.5846-3.019 1.5133-8.368 1.6482-14.084.0899-5.716-1.5582-10.256-4.3901-12.092-7.2294-.771-1.1837-1.064-2.3599-.764-3.4537.367-1.341 1.581-2.3598 3.371-2.9966 3.117-1.1163 7.979-1.0863 13.126.3221 5.146 1.4085 9.349 3.8432 11.469 6.3829 1.222 1.4609 1.753 2.9517 1.386 4.2927v.0075Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M271.614 79.6937c-.03.1124-.06.2248-.098.3371-.232.2997-.621.5245-.884.6443-1.79.9065-5.798 1.4234-11.245-.0599-5.438-1.4833-8.63-3.9631-9.709-5.6337-.157-.2472-.382-.6368-.442-1.0114.023-.1199.053-.2322.09-.3521.038-.1199.068-.2397.105-.3521 1.821-5.9334 8.046-9.402 14.077-7.7538 6.031 1.6481 9.649 7.8062 8.196 13.8445-.023.1124-.053.2322-.09.3446v-.0075Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M268.28 52.5529s-4.577 16.7813-4.585 16.8113c-.097.3671-.861.4794-1.7.2547-.839-.2248-1.446-.7192-1.349-1.0788.008-.0375 4.098-15.0282 4.098-15.0282s-7.177-7.2145-7.177-7.222c-.27-.2697 0-.9814.622-1.6107.614-.6218 1.333-.899 1.603-.6368 0 .0075 8.458 8.5031 8.458 8.5031h.038l-.008.0074Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="m266.198 50.4836-1.903 2.5697m3.955-.5103-3.506.9664m-.224.9381 3.049.5844"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="m189.154 197.206-4.944 3.319c-5.454 3.664-11.882 5.619-18.452 5.619H85.1853c-6.5702 0-12.9905-1.955-18.4519-5.619l-4.9445-3.319c-1.2736-.854-1.6107-2.577-.7566-3.85 1.0188-1.514 3.0715-1.918 4.5848-.899l2.9667 1.992c5.454 3.664 11.8818 5.619 18.4519 5.619h76.8563c6.571 0 12.998-1.955 18.452-5.619l2.967-1.992c1.513-1.019 3.566-.615 4.585.899.854 1.273.517 2.996-.757 3.85h.015Z"
            fill="#fff"
        />
        <path
            d="m189.154 197.206-4.944 3.319c-5.454 3.664-11.882 5.619-18.452 5.619H85.1853c-6.5702 0-12.9905-1.955-18.4519-5.619l-4.9445-3.319c-1.2736-.854-1.6107-2.577-.7566-3.85 1.0188-1.514 3.0715-1.918 4.5848-.899l2.9667 1.992c5.454 3.664 11.8818 5.619 18.4519 5.619h76.8563c6.571 0 12.998-1.955 18.452-5.619l2.967-1.992c1.513-1.019 3.566-.615 4.585.899.854 1.273.517 2.996-.757 3.85h.015Z"
            fill="url(#a)"
        />
        <path
            d="m189.154 197.206-4.944 3.319c-5.454 3.664-11.882 5.619-18.452 5.619H85.1853c-6.5702 0-12.9905-1.955-18.4519-5.619l-4.9445-3.319c-1.2736-.854-1.6107-2.577-.7566-3.85 1.0188-1.514 3.0715-1.918 4.5848-.899l2.9667 1.992c5.454 3.664 11.8818 5.619 18.4519 5.619h76.8563c6.571 0 12.998-1.955 18.452-5.619l2.967-1.992c1.513-1.019 3.566-.615 4.585.899.854 1.273.517 2.996-.757 3.85h.015Z"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M169.016 67.512s-22.512 3.9855-72.2791-3.2889l-.5094 5.1843c-1.4833 15.2155-8.518 29.3522-19.7554 39.7136l-5.424 5.004C59.1514 125.1 48.6556 137.506 39.808 151.059l-3.2064 4.907s.7117 5.446 18.1073 3.079c11.9866-1.633 37.2484-5.02 51.7971-6.967 7.08-.952 14.272.576 20.355 4.322l.509.315c7.956 4.899 17.493 6.398 26.626 4.442 7.963-1.7 18.182-2.015 25.936 4.218 0 0 14.046-33.667 25.973-47.19 11.927-13.522 27.037-25.8457 27.037-25.8457s-21.68 1.9778-35.083-8.9825"
            fill="#fff"
        />
        <path
            d="M169.016 67.512s-22.512 3.9855-72.2791-3.2889l-.5094 5.1843c-1.4833 15.2155-8.518 29.3522-19.7554 39.7136l-5.424 5.004C59.1514 125.1 48.6556 137.506 39.808 151.059l-3.2064 4.907s.7117 5.446 18.1073 3.079c11.9866-1.633 37.2484-5.02 51.7971-6.967 7.08-.952 14.272.576 20.355 4.322l.509.315c7.956 4.899 17.493 6.398 26.626 4.442 7.963-1.7 18.182-2.015 25.936 4.218 0 0 14.046-33.667 25.973-47.19 11.927-13.522 27.037-25.8457 27.037-25.8457s-21.68 1.9778-35.083-8.9825"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M272.168 98.3282c2.274-3.4519 2.372-7.3996.219-8.8175-2.153-1.4178-5.741.2312-8.015 3.6831-2.273 3.452-2.371 7.3992-.218 8.8172 2.152 1.418 5.741-.231 8.014-3.6828Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="m175.534 41.6266-30.963-26.7751c-2.113-1.828-5.177-1.7905-7.275.0899l-4.569 4.1054"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M133.139 21.6032c.12-1.7605-1.123-3.2813-2.779-3.3937-1.656-.1124-3.102 1.2211-3.229 2.9817-.12 1.7605 1.124 3.2738 2.787 3.3862 1.663.1124 3.101-1.2137 3.221-2.9742Z"
            fill="#1A1A1A"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="m150.782 77.9858-10.024 2.7195c-6.218 1.6856-11.927 4.8696-16.639 9.2672-6.66 6.218-15.253 9.9414-24.3405 10.5635l-.884.06m30.9025 15.754-16.452 9.964c-7.716 4.675-16.2789 7.776-25.2015 9.125-12.0016 1.82-23.299 6.795-32.7459 14.421l-2.2999 1.858m146.4693-42.757-29.547 25.157m36.866-74.7735 3.506-.472c2.907-.3896 4.81-3.0416 4.256-5.9259-.555-2.8843-3.364-4.907-6.271-4.5175l-6.195.8316"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <path
            d="M198.787 45.5832c-.135-.9814-1.034-1.6707-2.015-1.5358-.974.1273-1.663 1.0338-1.536 2.0152s1.034 1.6707 2.008 1.5358c.974-.1348 1.67-1.0338 1.543-2.0152Zm9.275-1.2427c-.135-.9814-1.034-1.6707-2.008-1.5358-.974.1348-1.67 1.0338-1.543 2.0152.127.9815 1.034 1.6707 2.015 1.5358.982-.1348 1.664-1.0338 1.536-2.0152Z"
            fill="#1A1A1A"
        />
        <path
            d="M197.335 52.5348c2.024 0 3.664-3.0288 3.664-6.765 0-3.7361-1.64-6.7649-3.664-6.7649-2.023 0-3.663 3.0288-3.663 6.7649 0 3.7362 1.64 6.765 3.663 6.765Zm6.157-3.8058c-.232-.8915-.367-1.8954-.367-2.9592 0-3.7383 1.641-6.7649 3.663-6.7649 2.023 0 3.664 3.0266 3.664 6.7649 0 .9365-.105 1.828-.285 2.6371"
            stroke="#1A1A1A"
            strokeWidth="0.884013"
            strokeLinejoin="round"
        />
        <defs>
            <pattern id="a" patternContentUnits="objectBoundingBox" width="0.0288568" height="0.262873">
                <use xlinkHref="#b" transform="scale(.00006 .00053)" />
            </pattern>
        </defs>
    </svg>
);
